import CloseCircleOutlined from '@ant-design/icons/CloseCircleOutlined'
import { useKestrelViewerContext } from 'features/kestrelViewer'
import { KestrelCommands } from 'features/kestrelViewer/types/KestrelCommands'
import React, { Dispatch, SetStateAction } from 'react'
import styled from 'styled-components'
import { KVMarkup, KVMeasurement } from 'types'

const CloseButtonContainer = styled.div`
  position: absolute;
  cursor: pointer;
`

export const CloseButton: React.FC<{
  setSelectedMarkup: Dispatch<SetStateAction<KVMarkup | undefined>>
  style?: React.CSSProperties
}> = ({ setSelectedMarkup, style }) => {
  const { sendCommand, selectedMarkup } = useKestrelViewerContext()

  return (
    <CloseButtonContainer
      style={style}
      onClick={() => {
        setSelectedMarkup(undefined)
        // If we're closing a measurement popup, send the unhighlight command
        if (selectedMarkup instanceof KVMeasurement) {
          sendCommand({
            command: KestrelCommands.UNHIGHLIGHT_ALL_MEASUREMENTS,
          })
        }
      }}>
      <CloseCircleOutlined style={{ transform: 'scale(1) translate(0, 0)' }} />
    </CloseButtonContainer>
  )
}
